"use client";

import chunk from "lodash/chunk";
import isEmpty from "lodash/isEmpty";
import { useContext, useMemo } from "react";
import MultiCarousel from "@stadium/ui/src/components/multi-carousel";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import StoreCard from "@sharedComponents/cards/store";

import styles from "./main.module.scss";
const emptyObj = {};

const FeaturedShops = ({ data, featuredShopMenu }) => {
  const { menuItems } = featuredShopMenu;
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { jsonContent } = data;
  const { title = "" } = JSON.parse(jsonContent) || emptyObj;

  const shops = useMemo(() => {
    return menuItems ? menuItems.flatMap((item) => item.linkedStoreResources)?.filter(Boolean) : [];
  }, [menuItems]);

  const renderShop = (shop) => {
    return <StoreCard data={shop} key={shop.id} />;
  };

  const renderShops = () => {
    if (isMobileDevice)
      return chunk(shops, 3).map((shopsList) => {
        return <div key={shopsList[0].id}>{shopsList.map(renderShop)}</div>;
      });
    return shops.map(renderShop);
  };

  const renderSection = () => {
    return (
      <article className={styles.productsRsow}>
        <MultiCarousel
          containerClass={styles.itemCarousel}
          showDots={true}
          resolutionCountsMapping={{ desktop: 3, mobile: 1 }}
          infinite={true}
        >
          {renderShops()}
        </MultiCarousel>
      </article>
    );
  };

  if (isEmpty(featuredShopMenu) || shops.length === 0) return null;

  return (
    <section className={styles.containerClass} id="featured-shops">
      <h3 className={styles.storeHeading}>{title || "Our Brand Shops"}</h3>
      {renderSection()}
    </section>
  );
};

export default FeaturedShops;
